import React from 'react';
import { useProductProperties } from '@yme/atoms/product-properties';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getItemImage } from '@yme/utils/common';
import { formatPrice } from '@yme/utils/formatPrice';
import { getProductURL } from '@yme/utils/product';
import { ProductPartWrapperStyled, RegularTextLevel5Styled, ProductPartName } from './styled';
export const RequiredProductVariantPanel = ({ item, isInAuthor, pdpPath, isRightToLeft, rootLanguage, productPropertiesLabels, currentVariant, }) => {
    const { slug, name } = item;
    const { images, sku, prices, attributes } = currentVariant;
    const [price] = prices;
    const itemImage = getItemImage(images);
    const itemUrl = getProductURL({
        path: pdpPath,
        isInAuthor,
        slug,
    });
    const { ProductProperties } = useProductProperties(attributes, productPropertiesLabels, false);
    return (React.createElement(ProductPartWrapperStyled, { itemUrl: itemUrl, itemImage: itemImage, isRightToLeft: isRightToLeft, className: "required-product-variant-panel", imageWrapperWidth: "48px" },
        React.createElement(FlexWrapper, { justifyContent: "space-between", isFullWidth: true, alignItems: "center", gap: "12px" },
            React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "flex-start" },
                React.createElement(RegularTextLevel5Styled, { color: colorCoreBlack300 },
                    `${sku}-`,
                    React.createElement(ProductProperties, null)),
                React.createElement(ProductPartName, { to: itemUrl }, name)),
            React.createElement(FlexWrapper, { alignSelf: "flex-start" }, price && (React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base }, formatPrice({
                locale: rootLanguage,
                currencyName: price.currencyCode,
                price: price.discount?.discountedPrice ?? price.amount,
            })))))));
};
